<template>
    <transition name="dialog-fade">
        <div v-if="visible" class="locomotive-dialog" @click="onBackdropClick">
            <div class="dialog__backdrop"></div>

            <div class="dialog__container" @click.stop>


                <!-- Animation radar de geolocalisation -->
                <div class="loader__radar">
                    <div class="radar__ring radar__ring--1"></div>
                    <div class="radar__ring radar__ring--2"></div>
                    <div class="radar__ring radar__ring--3"></div>
                    <div class="radar__center">
                        <svg class="radar__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
                                fill="currentColor" />
                            <circle cx="12" cy="9" r="2.5" fill="currentColor" />
                        </svg>
                    </div>
                </div>

                <!-- Texte de statut -->
                <div class="loader__text">
                    <h3 class="loader__title">{{ title }}</h3>
                    <p class="loader__subtitle">{{ subtitle }}</p>
                </div>

                <!-- Barre de progression indeterminee -->
                <div class="loader__progress-bar">
                    <div class="progress-bar__track">
                        <div class="progress-bar__fill"></div>
                    </div>
                </div>


            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'LocomotiveLoader',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Geolocalisation en cours'
        },
        subtitle: {
            type: String,
            default: 'Patientez, nous recherchons vos locomotives...'
        },

        closeOnBackdrop: {
            type: Boolean,
            default: true
        }
    },

    watch: {
        visible(val) {
            if (val) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
        }
    },

    beforeDestroy() {
        document.body.style.overflow = ''
    },

    methods: {
        onClose() {
            this.$emit('close')
        },

        onBackdropClick() {
            if (this.closeOnBackdrop) {
                this.onClose()
            }
        }
    }
}
</script>

<style scoped>
/* Overlay & backdrop */
.locomotive-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

.dialog__backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(4px);
}

/* Conteneur modal */
.dialog__container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.02);
    max-width: 420px;
    width: 90%;
    z-index: 1;
}

/* Bouton fermer */
.dialog__close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: #64748b;
    transition: all 0.2s ease;
    outline: none;
    padding: 0;
}

.dialog__close svg {
    width: 16px;
    height: 16px;
}

.dialog__close:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.dialog__close:active {
    transform: scale(0.93);
}

/* Animation radar */
.loader__radar {
    position: relative;
    width: 120px;
    height: 120px;
    margin-bottom: 32px;
}

.radar__ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 2px solid #3b82f6;
    opacity: 0;
}

.radar__ring--1 {
    width: 40px;
    height: 40px;
    animation: radar-pulse 2s ease-out infinite;
}

.radar__ring--2 {
    width: 80px;
    height: 80px;
    animation: radar-pulse 2s ease-out 0.5s infinite;
}

.radar__ring--3 {
    width: 120px;
    height: 120px;
    animation: radar-pulse 2s ease-out 1s infinite;
}

.radar__center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.4);
}

.radar__icon {
    width: 24px;
    height: 24px;
    color: white;
}

@keyframes radar-pulse {
    0% {
        transform: translate(-50%, -50%) scale(0.8);
        opacity: 0.6;
    }

    100% {
        transform: translate(-50%, -50%) scale(1.3);
        opacity: 0;
    }
}

/* Texte */
.loader__text {
    text-align: center;
    margin-bottom: 24px;
}

.loader__title {
    margin: 0 0 8px 0;
    font-size: 22px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: -0.5px;
}

.loader__subtitle {
    margin: 0;
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
}

/* Barre de progression */
.loader__progress-bar {
    width: 100%;
    margin-bottom: 20px;
}

.progress-bar__track {
    width: 100%;
    height: 4px;
    background: #e2e8f0;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
}

.progress-bar__fill {
    position: absolute;
    top: 0;
    left: -100%;
    width: 60%;
    height: 100%;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
    border-radius: 2px;
    animation: progress-slide 1.5s ease-in-out infinite;
}

@keyframes progress-slide {
    0% {
        left: -60%;
    }

    100% {
        left: 100%;
    }
}

/* Transitions */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
    transition: opacity 0.3s ease;
}

.dialog-fade-enter-active .dialog__container,
.dialog-fade-leave-active .dialog__container {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.dialog-fade-enter .dialog__container,
.dialog-fade-leave-to .dialog__container {
    transform: scale(0.92);
    opacity: 0;
}

.dialog-fade-enter-to .dialog__container,
.dialog-fade-leave .dialog__container {
    transform: scale(1);
    opacity: 1;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
    opacity: 0;
}
</style>